import { Button } from "@bokio/designsystem/components/Button";
import { RenderRequestError } from "@bokio/designsystem/components/Loading";
import { Modal, ModalContent, ModalFooter } from "@bokio/designsystem/components/Modal";
import { SG } from "@bokio/designsystem/components/SpacingGroup/SpacingGroup";
import { GeneralLangFactory } from "@bokio/lang";

import type { RequestState } from "@bokio/mobile-web-shared/services/api/requestState";
import type { ReactNode } from "react";

export interface ConfirmationModalProps {
	title: ReactNode;
	isVisible: boolean;
	isLoading?: boolean;
	submitText?: string;
	cancelText?: string;
	disabled?: boolean;
	disabledSubmit?: boolean;
	onConfirm?: () => void;
	onCancel: () => void;
	isDelete?: boolean;
	submitButtonTestId?: string;
	cancelButtonTestId?: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	request?: RequestState<any>;
	children: ReactNode;
	contentClassName?: string;
}

const ConfirmationModal2 = (props: ConfirmationModalProps) => {
	const generalLang = GeneralLangFactory();
	const {
		title,
		submitText,
		isVisible,
		cancelText,
		disabled,
		disabledSubmit,
		isDelete,
		onCancel,
		onConfirm,
		children,
		isLoading,
		submitButtonTestId,
		cancelButtonTestId,
		request,
		contentClassName,
	} = props;

	return (
		<Modal alwaysMounted={true} title={title} visible={isVisible} onClose={onCancel}>
			<ModalContent className={contentClassName}>
				<SG gap="16">
					{children}
					<RenderRequestError noNoticeTopMargin request={request} />
				</SG>
			</ModalContent>
			<ModalFooter centered={true}>
				<Button
					testId={cancelButtonTestId}
					appearance="secondary"
					onClick={onCancel}
					disabled={disabled || isLoading || request?.isLoading}
				>
					{cancelText || generalLang.Cancel}
				</Button>
				{onConfirm && (
					<Button
						testId={submitButtonTestId}
						onClick={onConfirm}
						disabled={disabled || disabledSubmit}
						appearance={isDelete ? "destructive" : "primary"}
						loading={isLoading || request?.isLoading}
					>
						{submitText || generalLang.Yes}
					</Button>
				)}
			</ModalFooter>
		</Modal>
	);
};

export default ConfirmationModal2;
